import React, { FC, useEffect } from 'react'
import _ from 'lodash'
// types
import { FolderReportProps, ReportFormParameters } from './reports'

type ReportType = 'folder_valuation'
const displayName = 'Valuation Summary'

type VacancyReportParameters = ReportFormParameters & {
  report: ReportType
}

const ValuationSummary: FC<FolderReportProps> = (props) => {
  useEffect(() => {
    props.setParameters(getParameters())
    props.setValid(true)
  }, [])

  function getParameters(): VacancyReportParameters {
    return {
      report: 'folder_valuation'
    }
  }

  return <></>
}

ValuationSummary.displayName = displayName
export default ValuationSummary
